import { reactive, Div, H3, Button, Label, RadioInput, Input, Span, Checkbox, P, A } from 'alkali'
import { analysisSelections, structuredQuery, selectedStudies } from 'model/SearchQuery'
import { questionToText } from 'analysis/Question'
import { registerScreeningConfirmation } from 'model/Screening'
import Dialog from '../generic/DialogAlkali'
import { patch } from 'tools/request'
import { Toggle } from 'components/generic/Toggle'
import './ScreeningDialog.scss'


registerScreeningConfirmation(() => {
	return new Promise(resolve => {
		new ScreeningDialog({
			onConfirm: resolve
		}).show()
	})
})
export class ScreeningDialog extends Dialog {
	get defaults() {
		return {
			head: {
				titleText: 'Welcome to Screening',
			},
			id: 'screening-dialog',
			// set choice default to include
			foot: {},
		}
	}
	ready(properties) {
		let name = reactive(questionToText(analysisSelections.question.valueOf()))
		let description = reactive('')
		let hasSelectedStudies = selectedStudies.valueOf().length > 0
		let dismissed = reactive(app.user.Settings?.Tour?.Screening)
		const includeStudies = reactive(Boolean(app.user.Settings?.IncludeSelectedStudiesInScreening ?? true))
		const autoFavorite = reactive(Boolean(app.user.Settings?.AutoFavoriteScreeningAnalysis ?? true))
		const confirm = () => {
			if (!app.user.Settings.Tour)
				app.user.Settings.Tour = {}
			app.user.Settings.Tour.Screening = dismissed.valueOf()
			app.user.Settings.IncludeSelectedStudiesInScreening = includeStudies.valueOf()
			app.user.Settings.AutoFavoriteScreeningAnalysis = autoFavorite.valueOf()
			patch('/portal/User/' + app.user.Id, { data: { Settings: app.user.Settings } })
			if (!includeStudies.valueOf()) {
             	selectedStudies.put([])
            }
			properties.onConfirm(this)
        }
		this.body.append(
			Div('.screening-body', [
				Div([P('You have initiated screening for the current query.')]),
				// To Do: To be added later I believe
				// Label(['Do not show this dialog when starting screening', Checkbox({ checked: dismissed })]),
				...(hasSelectedStudies ? [
					Div('.existing', [
						P(["There are selected studies in the", Span('.strong', [" Search Results"]), " tab."]),
						P("Please select below if you would like to include these studies in your screening."),
					]),
					Div('.toggle-container', [
						Span('.strong', ['Clear Selections']),
						Toggle({
							id: 'selection-choice',
							checked: includeStudies,
							name: 'selection-choice'
						}),
						Span('.strong', ['Include Selected Studies']),
					]),
					P('.note', [Span('.strong', ["Note: "]), "Clearing selections will uncheck selected studies in ", Span('.strong', [" Search Results"]), "."]),
				] : []),
				Div('.toggle-container', [
					Span('.strong', ['Do not Favorite Analysis']),
					Toggle({
						id: 'selection-choice',
						checked: autoFavorite,
						name: 'selection-choice'
					}),
					Span('.strong', ['Favorite Analysis']),
				]),
				P('.help', [
					Span('To learn more about how DocAnalytics can help with screening, click'),
					A('.strong', {href: 'https://confluence.doctorevidence.com/display/shareit/67502210/YZT9f6505f2c655461ebe29b0baae7b7e22FCB#DocAnalyticsHelp-ScreeningScreening',
					target: '_blank'}, ['here']),
					Span('.')
				])
			]),

		)
		this.footer.rightControls.append(
			Button('.btn', {
				textContent: 'Cancel',
				onclick: () => {
					try {
						properties.onConfirm(null)
						this.hide()
					} catch (error) {
						alert(error)
					}
				},
			}),
			Button('.btn.primary', {
				textContent: 'Continue Screening',
				onclick: () => {
					try {
						confirm()
					} catch (error) {
						alert(error)
					}
				},
			}),
		)

	}
}
